import { buildTheme } from "../const"
import { setMuiColor } from "../const/baseTheme"

const LABO_BRANDING = setMuiColor({
  main: "#087CA1",
  // Dark
  dark1: "#0B5874",
  dark2: "#0F6585",
  dark3: "#053247",
  dark4: "#112339",
  // Light
  light1: "#28C1F2",
  light2: "#9ADCFF",
  light3: "#F4F7FF",
  light4: "#F4F7FF",
})
const LABO_BRANDING_ACCENT = setMuiColor({
  main: "#20B1FD",
  // Dark
  dark1: "#089FEF",
  dark2: "#007FCC",
  dark3: "#035588",
  dark4: "#035588",
  // Light
  light1: "#57C5FF",
  light2: "#B8E4FF",
  light3: "#DFF1FF",
  light4: "#DFF1FF",
})

export const laboratoryTheme = buildTheme(({ palette }) => ({
  palette: {
    branding: LABO_BRANDING,
    brandingAccent: LABO_BRANDING_ACCENT,
    header: {
      containedButton: {
        backgroundColor: LABO_BRANDING.dark1,
        primaryColor: palette.common.white,
        secondaryColor: LABO_BRANDING.dark2,
        hover: {
          backgroundColor: LABO_BRANDING.dark3,
        },
      },
      gradient: `linear-gradient(-180deg,${"#2d8cab"} 0%,${"#077ca1"} 100%)`,
    },
    background: {
      default: "#f7f7f7",
    },
    p3Components: {
      sideNavTitle: palette.primary.light1,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: "contained" },
              style: {
                color: palette.getContrastText(LABO_BRANDING.dark1),
                backgroundColor: LABO_BRANDING.dark1,
                "&:hover": {
                  backgroundColor: LABO_BRANDING.dark2,
                },
              },
            },
          ],
        },
      },
    },
  },
}))
